import React, { Component } from "react";

import Decimal from "decimal.js";

import CardUtils from "../Models/CardUtils";
import { Text, Box, Divider, HStack, Spacer, Tag, Button, Input, Center, VStack } from '@chakra-ui/react'
import { faCancel } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function isNormalInteger(val) {
  var n = Math.floor(Number(val));
  return n !== Infinity && String(val) === val && n >= 0;
}

export default class BasketQuantityCountInput extends Component 
{
  constructor(props) {
    super(props);
    this.berryValueInput = React.createRef();

    this.state = {
      valid: false,
      basketList: [],
      currBerryValue: null,
      errMsg: null,

      containerCount: null,
      containerQty: null,
      unitQty: null
    }

    this.addNewBasket = this.addNewBasket.bind(this);
    this.removeBasket = this.removeBasket.bind(this);
    this.onChangeBerryCount = this.onChangeBerryCount.bind(this);
    this.createBasketDisplay = this.createBasketDisplay.bind(this);
    this.recalcTotals = this.recalcTotals.bind(this);

  }


  componentDidMount(){
    if (this.props.cardValue)
    {
      var basketList = this.props.cardValue ?? [];
      this.setState({basketList: basketList});
      this.recalcTotals(basketList);
      this.berryValueInput.current.value = "";
      this.berryValueInput.current.select();
      this.berryValueInput.current.focus();
    }


}


  addNewBasket() 
  {
    if (!isNormalInteger(this.state.currBerryValue))
    //var pInt = parseInt(this.state.currBerryValue);
    //if (isN(pInt))
    {
      this.setState({
        //currBerryValue: null,
        errMsg: "Please enter a valid number."
      });
      this.berryValueInput.current.select();
      this.berryValueInput.current.focus();
      return;
    }
    var newBasket = {};
    newBasket.basketIdx = this.state.basketList.length + 1;
    newBasket.basketQty = parseInt(this.state.currBerryValue);
    var newBasketList = this.state.basketList;
    newBasketList.push(newBasket);
    this.setState({
      basketList: newBasketList,
      currBerryValue: null
    });
    this.recalcTotals(newBasketList);
    this.berryValueInput.current.value = "";
    this.berryValueInput.current.select();
    this.berryValueInput.current.focus();
    
  }

  onChangeBerryCount(e) 
  {
    this.setState({
      errMsg: null,
      currBerryValue: e.target.value
    })
    console.log(e.target.value)
  }

  createBasketDisplay() {
    var basketDisplayLines = [];
    this.state.basketList.map((entry) => {
      basketDisplayLines.push(

        <HStack width="-webkit-fill-available" justifyContent='space-between' marginBottom={"20px"}><Text>{(this.props.card.listUnitQtyTypeTitle) ? this.props.card.listUnitQtyTypeTitle: "Unit"} {entry.basketIdx}</Text> <Text textAlign={'left'}>{(this.props.card.listUnitQtyTypeTitle) ? this.props.card.listUnitQtyTypeTitle: ""} {entry.basketQty}</Text>
          <FontAwesomeIcon icon={faCancel} color='white' onClick={(e) => { this.removeBasket(entry.basketIdx) }} />
        </HStack>
      )
    })
    return basketDisplayLines;
  }

  removeBasket(idx) {
    console.log(idx)
    var currentBasketList = this.state.basketList;
    var newBasketList = [];
    var x = 0;
    for (var i = 0; i < currentBasketList.length; i++) {
      if (i !== (idx - 1)) {
        newBasketList.push(currentBasketList[i])
        newBasketList[x].basketIdx = x + 1;
        x = (x + 1)
      }
    }
    this.setState({
      basketList: newBasketList
    });
    this.recalcTotals(newBasketList);
    this.berryValueInput.current.value = "";
    this.berryValueInput.current.select();
    this.berryValueInput.current.focus();
  }

  recalcTotals(basketList)
  {
    var containerCount = basketList.length;

    var containerQtyList = basketList.map((b) => {return b.basketQty});
    var unitQty = containerQtyList.reduce((accumulator, currentValue) => {
      return accumulator + currentValue
    },0);

    var containerQty = parseInt( unitQty /containerCount);
    if (isNaN(containerQty))
    {
      containerQty = 0;
    }

    this.setState
    ({
        containerCount: containerCount,
        containerQty: containerQty,
        containerQtyList: basketList,
        unitQty: unitQty
      });
    //let containerCount = this.props.valueBag[CardUtils.titleToId(this.props.card.containerCountTitle)];
    //let containerQty = this.props.valueBag[CardUtils.titleToId(this.props.card.containerQtyTitle)]; 
    //let unitQty = this.props.valueBag[CardUtils.titleToId(this.props.card.unitQtyTitle)];

    this.props.onValueChange(containerCount, CardUtils.titleToId(this.props.card.containerCountTitle));
    this.props.onValueChange(containerQty, CardUtils.titleToId(this.props.card.containerQtyTitle));
    this.props.onValueChange(basketList, "containerQtyList");
    this.props.onValueChange(unitQty, CardUtils.titleToId(this.props.card.unitQtyTitle));
    this.props.onValueChange(basketList, this.props.card.id); // set the actual card ID value
  }

  render() 
  {

    return (
      <Center color={'white'} flexDirection='column' width="70vw" marginLeft="10%">


            <HStack>
                <VStack>
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="grey" margin='0'>{this.props.card.containerCountTitle}</Text> 
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="grey" margin='0'>{this.state.containerCount}</Text>
                </VStack>

                <VStack>
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="grey" margin='0'>{this.props.card.containerQtyTitle}</Text> 
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="grey" margin='0'>{this.state.containerQty}</Text> 
                </VStack>

                <VStack>
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="grey" margin='0'>{this.props.card.unitQtyTitle}</Text> 
                    <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }} color="grey" margin='0'>{this.state.unitQty}</Text> 
                </VStack>
     

            </HStack>

            <Divider />


        {this.createBasketDisplay()}

        <HStack width="-webkit-fill-available" justifyContent='space-between'>
          <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }}>{(this.props.card.listUnitTypeTitle) ? this.props.card.listUnitTypeTitle : "Unit"} {this.state.basketList.length + 1} </Text>
          <HStack justifyContent={"flex-end"}>
          <Text fontSize={{ base: '10px', md: '16px', lg: '20px' }}>{(this.props.card.listEditLabel) ? this.props.card.listEditLabel: ""} </Text>
          <Input
            ref={this.berryValueInput}
            value={this.state.currBerryValue}
            backgroundColor='white'
            width={'30vw'}
            color='black'
            onChange={(e) => { this.onChangeBerryCount(e) }}
            
          />
          </HStack>
          <HStack>
          <Button
            colorScheme="blue"
            onClick={() => this.addNewBasket()}
          >
            Add {(this.props.card.listUnitTypeTitle) ? this.props.card.listUnitTypeTitle: "Unit"}
          </Button>
          <Spacer/><Spacer/>
          <Text color="red" fontSize="small" >{this.state.errMsg}</Text>
          </HStack>
        </HStack>

      </Center>
    )
  }
}







